module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 9-69787d1abaa81c84be6b8973cb05271e.jpg";